import type { NomenclatureTypeOption } from '../../types';

export const NOMENCLATURE_TYPE_PRODUCT = 1;
export const NOMENCLATURE_TYPE_TESTER = 2;

export type NomenclatureFormType = Record<number, NomenclatureTypeOption>;

export const NOMENCLATURE_TYPES: NomenclatureFormType = {
  [NOMENCLATURE_TYPE_PRODUCT]: {
    id: NOMENCLATURE_TYPE_PRODUCT,
    label: 'Продукт',
  },
  [NOMENCLATURE_TYPE_TESTER]: {
    id: NOMENCLATURE_TYPE_TESTER,
    label: 'Тестер',
  },
};
